gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", function () {
  setTimeout(initProduceHorizontal, 300);
});

window.addEventListener("resize", function () {
  clearTimeout(window.produceHorizontalTimer);
  window.produceHorizontalTimer = setTimeout(initProduceHorizontal, 300);
});

function initProduceHorizontal() {
  const produce = document.querySelector("#top-produce");
  const wrapper = document.querySelector("#top-produce .p-produce-horizontal-slider-wrap");
  const slides = gsap.utils.toArray("#top-produce .p-produce-horizontal-area");

  if (!produce || !wrapper || !slides.length) return;

  const oldTrigger = ScrollTrigger.getById("top-produce-horizontal");
  if (oldTrigger) {
    oldTrigger.kill();
  }

  gsap.killTweensOf(wrapper);

  gsap.set(wrapper, {
    x: 0,
    clearProps: "transform"
  });

  const getScrollAmount = function () {
    return wrapper.scrollWidth - window.innerWidth;
  };

  if (getScrollAmount() <= 0) return;

  gsap.to(wrapper, {
    x: function () {
      return -getScrollAmount();
    },
    ease: "none",
    scrollTrigger: {
      id: "top-produce-horizontal",
      trigger: produce,
      start: "top top",
      end: function () {
        return "+=" + getScrollAmount() * 2.1;
      },
      pin: true,
      scrub: 1.2,
      anticipatePin: 1,
      invalidateOnRefresh: true
    }
  });

  ScrollTrigger.refresh(true);
}